import NextImage from 'next/image'

import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogOverlay, DialogContent } from '@wartek-id/dialog-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type SubmitConfirmationDialogProps = Omit<DialogProps, 'children'> & {
  onCancel?: () => void
  onConfirm?: () => void
  isLoading?: boolean
  title?: string
  confirmCta?: string
}

export function SubmitConfirmationDialog({
  onCancel,
  onConfirm,
  isLoading,
  title = 'Kumpulkan dokumen?',
  confirmCta = 'Kumpulkan',
  ...dialogProps
}: SubmitConfirmationDialogProps) {
  return (
    <Dialog size="sm" closeOnOverlayClick={false} {...dialogProps}>
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-4">
          <NextImage
            src={'/illustrations/img-publish-data.png'}
            alt=""
            height={84}
            width={84}
          />

          <div className="space-y-1">
            <Text variant="display-sm">{title}</Text>
            <Text color="subdued" variant="body-lg">
              Anda dapat ubah isi dokumen jika diperlukan, selama belum dinilai
              oleh Kepala Sekolah.
            </Text>
          </div>

          <div className="flex space-x-5">
            <Button
              onClick={onCancel}
              color="white"
              size="lg"
              disabled={isLoading}
            >
              Kembali
            </Button>
            <Button
              onClick={onConfirm}
              color="blue"
              size="lg"
              isLoading={isLoading}
              disabled={isLoading}
            >
              {confirmCta}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
